import { formatMetric } from '../utils/analyticsHelpers';

export default function StatCard({ label, value, format = 'default', colorize = false }) {
  const formatted = formatMetric(value, format);
  const n = typeof value === 'number' ? value : parseFloat(value);

  let valueClass = 'stat-card-value';
  if (colorize && !isNaN(n)) {
    if (n > 0) valueClass += ' pnl-positive';
    else if (n < 0) valueClass += ' pnl-negative';
  }

  return (
    <div className="stat-card">
      <span className="stat-card-label">{label}</span>
      <span className={valueClass}>{formatted}</span>
    </div>
  );
}
